/**
 * A link that looks like a button (Pico styles `a[role="button"]`), so the
 * a11y lint exception lives in one place.
 */
const LinkButton = ({
  type = "primary",
  small = false,
  children,
  ...props
}) => (
  // biome-ignore lint/a11y/useSemanticElements: Pico styles links as buttons
  <a
    role="button"
    data-button-type={type}
    sz={small ? "small" : undefined}
    {...props}
  >
    {children}
  </a>
);

export default LinkButton;
